export default "__VITE_ASSET__clcs3bgN__"